module.exports = __webpack_public_path__ + "static/icon_color_walking-c21138ec3cdf324315a44afdc7049cd4.png";